// extracted by mini-css-extract-plugin
module.exports =  {"spinner-outer":"Show-c0w7__spinner-outer","spinner":"Show-QdpI__spinner"};